export enum TireTypeEnum {
  SUMMER,
  WINTER,
}
